export default __webpack_public_path__ + "static/media/aspire-logo.7b7cb51c.png";